// Copyright (c) Bentley Systems
import { SVGProps, useEffect, useState } from "react";
import { animated, useSprings } from "@react-spring/web";
import { AnimatedIconProps } from "./AnimatedIconProps";

const BottomRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#67b01a"
        fillOpacity="60%"
        stroke="#fff"
        strokeOpacity="0.6"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(5 5)"
       />
      <path
        fill="#fff"
        transform="matrix(1.8 0 0 2 12 10)"
        xmlns="http://www.w3.org/2000/svg"
        d="M12.817 2.56c.202-2.097.737-1.95.737-1.95A6.966 6.966 0 0114 2.56zM8.89 7a1.97 1.97 0 01.898.216l1.424.732c.357-2.615.81-6.027.81-6.027S12.139.04 13.127 0H4.433S3.405.04 3.168 1.6a806.5 806.5 0 00-.962 6.98h4.817A1.856 1.856 0 018.89 7zM7 9.439H0S.367 12 1.304 12H7zm2.33-1.334l6.222 3.2a.85.85 0 01.33.298.758.758 0 01-.33 1.092l-6.222 3.2a.966.966 0 01-.441.105.848.848 0 01-.889-.8V8.8a.848.848 0 01.889-.8.965.965 0 01.44.105z"
      />
    </g>
  );
}

const TopRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#87cd1e"
        stroke="#83c444"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(0)"
       />
    </g>
  );
}

const ScriptRunAnim = (props: AnimatedIconProps) => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (props.isFocused !== undefined) {setToggle(props.isFocused);}
  }, [props]);

  const rectangles = [
    <TopRectangle key="rectangle1" />,
    <BottomRectangle key="rectangle2" />,
  ];

  const springs = useSprings(
    rectangles.length, // the number of springs to create
    rectangles.map((el, index) => {
      return {
        transform: toggle
          ? `translate3d(0px, 0px, 0px)`
          : `translate3d(${index === 1 ? -5 : 5}px, 0px, 0px)`,
      };
    })
  );

  const animatedRectangles = springs.map((animatedStyle, index) => (
    // use `animated.g` instead of `g` as the `animatedStyle`
    // is a special react-spring flavour of the `style` property
    <animated.g
      key={index}
      style={animatedStyle} // apply the animated style
    >
      {rectangles[index]}
    </animated.g>
  ));

  return (
    <div
      onMouseOver={() => {
        if (props.isFocused === undefined) {setToggle(true);}
      }}
      onMouseOut={() => {
        if (props.isFocused === undefined) {setToggle(false);}
      }}
    >
      <svg
        style={{ height: "100%", width: "100%" }}
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="47"
        viewBox="0 0 47 47"
      >
        {animatedRectangles}
      </svg>
    </div>
  );
};

export default ScriptRunAnim;
